import React, { useState, useEffect, useCallback } from 'react';
import Spanner from './../../assets/spanner.png';
import Helmet from './../../assets/helmet.png';

import { Icon,
         Container
      } from './CustomEvent.style';

const iconCondition = (type) => {
  if(type === 'action') {
    return Helmet;
  }
  else if (type === 'service') {
    return Spanner;
  }
  else {
    return Helmet;
  }
}

const CustomEvent = props => {

  const click = () => {
    console.log('props', props)
  }

  let showInCalendarAsScheduledInGreen;
  props.event.payload.map(item => {
    if(item.showInCalendarAsScheduledInGreen === true) {
      return showInCalendarAsScheduledInGreen = true;
    } else {
      return showInCalendarAsScheduledInGreen = false;
    }
  })

  let showInCalendarAsInProgressInGreen;
  props.event.payload.map(item => {
    if(item.showInCalendarAsInProgressInGreen === true) {
      return showInCalendarAsInProgressInGreen = true;
    } else {
      return showInCalendarAsInProgressInGreen = false;
    }
  })

  return (
    <Container stage={props.event.stage} showInCalendarAsScheduledInGreen={showInCalendarAsScheduledInGreen} showInCalendarAsInProgressInGreen={showInCalendarAsInProgressInGreen} onClick={() => click()}>
      <div style={styles.iconContainer}>
        <Icon src={iconCondition(props.event.type)}/>
      </div>
      <div style={styles.text}><span style={styles.quantity}>({props.event.quantity})</span> {props.title}</div>
    </Container>
  );
}


export default CustomEvent;

const styles = {
  text: {
    color: '#000',
    marginLeft: 5,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  iconContainer: {
    width: 15
  },
  quantity: {
    color: '#000',
  }
}
